class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (window.matchMedia("(min-width: 990px)").matches) {
      this.mainDetailsToggle.setAttribute("open", "");
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", true);
    }
  }

  onMouseLeave() {
    if (window.matchMedia("(min-width: 990px)").matches) {
      this.close();
    }
  }

  close() {
    const details = this.mainDetailsToggle;
    const submenu = details.querySelector(".header__submenu");

    if (submenu) {
      details.classList.add("menu-closing");

      let isClosed = false;
      const onAnimationEnd = () => {
        if (isClosed) return;
        isClosed = true;
        details.removeAttribute("open");
        details.classList.remove("menu-closing");
        details.querySelector("summary").setAttribute("aria-expanded", false);
      };

      submenu.addEventListener("animationend", onAnimationEnd, { once: true });
      setTimeout(onAnimationEnd, 500);
    } else {
      super.close();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
